import { stringify, ParsedUrlQuery } from 'querystring';
import { EXTERNAL_PATHS, PATHS } from '../constants';

const getAuthenticatedRedirectUrl = (
  /** Informs react-universal where to navigate next, usually in case of success */
  nextPathname: string,
  /** Other params to set, such as `return`, which is often used for back or close buttons */
  query: ParsedUrlQuery,
  /** Auth endpoint is determined by the 'auth-migration' feature flag */
  isAuthMigrationEnabled: boolean,
): string => {
  const querystring = stringify({
    ...query,
    next: nextPathname,
  });
  const LOGIN = isAuthMigrationEnabled ? PATHS.LOGIN : EXTERNAL_PATHS.LOGIN;
  return `${LOGIN}?${querystring}`;
};

export default getAuthenticatedRedirectUrl;
